



import React, {useState, useContext, useEffect} from "react";
import { Switch, Route } from "react-router-dom";
import styled, {css} from "styled-components";
import StoreSbColor from "./StoreSbColor";
import StoreSbSize from "./StoreSbSize";
import { Scrollbars } from 'react-custom-scrollbars';
import Sb0top from "./Sb0top";
import { ProductContext } from '../context'
import { themes, sections } from '../defaults';

import { SbSelect } from './SbSelect';


import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Pill,
  Button,
  Breadcrumbs,
  Slider,
  Head,
  Card,
  Input,
  RadioGroup,
  Icon,
  ButtonAction,
  Tag,
  Notification,
  ContentBlock
} from "xsolla-uikit";

// import {CssLoginPop0, CssSelectB} from '../components/Navbar';
import { SbCatSelect } from '../sb/SbSelect';


import ColorRandomizer from "./ColorRandomizer";
import "./sb.css";
import { relative } from "path";

export function SbThemeSelector({
  target = 'global',
}) {

  const valueFromContext = useContext(ProductContext);

  // const theme = React.useContext(ProductContext).getTheme();



  const [state, setstate] = useState({
    changeColor: 'colorAccent',
  })


  const menuHandler1 = (val) => {
    menuHandler(0, 'activeModule', val);
  }
  const menuHandler2 = (val) => {
    menuHandler(0, 'activeGroup', val);
  }


  const menuHandler = (blockOrder = 0, module = 'activeModule', newActive) => {
    let newSections = [...valueFromContext['sections']];
    newSections[blockOrder][module] = newActive;
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }

  const ifActive = ()=> {
    let act = false;
    if (target === 'global') {
      return getActive(valueFromContext.theme['id'])
    } else {
      return valueFromContext.sections[target].theme ? getActive(valueFromContext.sections[target].theme['id']) : false
    }
  }

  const getActive = (currentThemeId)=> {
    let ret;
    themes.forEach((oneTheme, ind) => {
      return ret = oneTheme['id'] === currentThemeId ? ind : ret;
    })
    return ret;
  }




  const deleteSection = (deleteSection) => {
    let newSections = [...valueFromContext['sections']];
    if (newSections.length > 1) {newSections.splice(deleteSection, 1)}
    valueFromContext.setStateFrom(
      'sections', newSections
      // 'activeModule', newActive
    )
  }


  const createSection = () => {
    let newSections = [...valueFromContext['sections']];
    let newSection = {...valueFromContext['sections'][valueFromContext['sections'].length - 1]}
    // newSection['menu'] = true;
    newSection['title'] = true;
    newSection['cardWidth'] = 200;
    newSection['limit'] = 0;
    newSections.push(
      newSection
    )

    valueFromContext.setStateFrom(
      'sections', newSections
    )
  }




  const [shown, setShown] = React.useState(false)


  if (valueFromContext) {return (

          <SbSelect

            active = {ifActive()}
            // active = {target === 'global' ? getActive(valueFromContext.theme['id']) : getActive(valueFromContext.sections[target].theme['id'])}
            // active = {getActive(valueFromContext.theme['id'])}
            // active={(target === 'global') ?
            //   getActive(valueFromContext.theme['id'])
            //     : valueFromContext.sections[target].theme
            //     ? getActive(valueFromContext.sections[target].theme['id'])
            //     : false
            // }

            placeholder="Custom theme"
            // menuHandler={(val)=>{valueFromContext.setStateFrom('theme', themes[val])}}
            menuHandler={(val)=>{valueFromContext.changeTheme(target, themes[val])}}
            extra = {<div style={{padding: '6px 0 4px 0', width: '100%'}}><StoreSbColor height={64} changeOneAtt={'colorBg'} type='random' target={target} /></div>}
            default = {valueFromContext['theme']}
            handleReset = {()=>{valueFromContext.changeTheme(target, null)}}
            options={themes.map((oneTheme, ind)=>(
                {
                  title: ()=>{
                    return (
                      <div
                      key={`value_${ind}`}
                      style={{
                            alignSelf: 'stretch',
                            justifySelf: 'stretch',
                            position: 'relative',
                            width: '100%',
                            borderRadius: '4px',
                            margin: '2px 0',
                            padding: '0 8px',
                            // left: '-4px',
                            // right: '-4px',
                            display: 'flex',
                            alignItems: 'center',
                            color: oneTheme['colorText'],
                            backgroundColor: oneTheme['colorBg'],
                          }}>

                          <div style={{color: oneTheme['colorAccent'],
                              borderRadius: 100,
                              backgroundColor: oneTheme['colorAccentText'],
                              width: 20,
                              height: 20,
                              marginRight: 8,
                            }}
                            className="xx_but_menu_icon xx_but_sett_icon--blue">
                              <div>play_circle_filled</div>
                            </div>

                            {oneTheme['name']}

                        </div>

                    )
                  },
                  value: ind,
                }
            ))}
          />)} else {
            return null;
          };
}


const CssSb00 = styled.div`
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0;
  height: 100%;
  padding: 64px 24px 0 24px;
  display: flex;
  width: 320px;
  flex-direction: column;
  /* width: 100%; */
  align-items: center;
  justify-content: center;
  /* align-content: stretch; */
  /* height: 100vh; */

  & div {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }
`;


const CssColorSwitcher = styled.div`
  width: 100%;
  display: grid;
  /* grid-template-columns: auto; */
  grid-auto-flow: column dense;
  grid-column-gap: 6px;
  margin-bottom: 4px;
`;


const CssColorSwitch = styled.div`
  flex-grow: 1;
  cursor: pointer;
  /* background-color: #506373; */
  display: flex;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border: 1px solid rgba(145, 159, 169, 0.17);
  color: #ccdbea;
  ${props => props.active && css`
    background: white;
    color: #506373;
  `}
  &:hover {
    border: 1px solid #ddd;
  }
`;


const CssSbSection = styled.div`
  /* background-color: #506373; */
  display: flex;
  width: 100%;
  align-items: center;
  margin: 16px;
  padding: 16px;
  border: 1px solid #ddd;
`;
const CssSbSectionH = styled.div`
  /* background-color: #506373; */
  display: flex;
  align-items: center;
`;





const SbLine = ({
  children,
}) => {
  return (
    <div className="xsb_set_line xsb_set_line--fullsub">{children}</div>
  )
}















export const CssLoginPop0 = styled.div`

  @media (max-width: 991px) {

  }

  @media (max-width: 767px) {

  }

  @media (max-width: 479px) {

  }
`



export const CssSelectB = styled.div`
  transition: all 150ms ease-in-out;
  transform: translateY(-8px);
  padding: 0;
  opacity: 0;
  ${({shown}) => shown && css`{
    transform: translateY(0px);
    opacity: 1;
    z-index: 1;
  }`};

`

export const CssSelect = styled.div`
  overflow: ${({shown}) => shown ? 'visible' : 'hidden'};
`
export const CssMenuLi = styled.div`
  background-color: ${({active}) => active ? '#157afb' : 'transparent'};
  color: ${({active}) => active ? 'white' : 'inherit'};
`




export function SbCollapsible({
  opened = true,
  children
}) {
  let [open, setOpen] = useState(opened);
  return (
    <div className="xx_set_line" style={{display: 'block'}}>

      <CssCollapsible
        open={open}
        // className="xx_set_sect"
        onClick={()=>{!open && setOpen(true)}}
        >

          {open && <CssIcon className="xx_but_menu_icon xx_but_sett_icon--blue"
            style={{right:0}}
            onClick={()=>{setOpen(!open)}}
          ><div>expand_less</div></CssIcon>}

          {!open && <CssIcon className="xx_but_menu_icon xx_but_sett_icon--blue"
            style={{right:0}}
          ><div>expand_more</div></CssIcon>}

          {children}
      </CssCollapsible>

    </div>
)}




export const CssIcon = styled.div`
  position: absolute;
  right: 24px;
  height: 52px;
  cursor: pointer;
  z-index: 0;
`




export const CssCollapsible = styled.div`
  position: relative;
  max-height: 54px;
  overflow: hidden;
  transition: all 150ms ease-in-out;

  ${({open}) => open && css`{
    max-height: none;
    overflow: auto;
  }`};
`


